module.exports = __webpack_public_path__ + "static/img/5.8c7ae64b.jpg";